import React from "react";

import isEmpty from "lodash.isempty";
import * as PropTypes from "prop-types";
import styled from "styled-components";

import iconPaths from "./paths/paths";

const StyledIcon = styled.svg`
  color: ${({ theme, color }) => color || theme.negativeTextColor};
  display: inline-block;
  vertical-align: middle;
  min-width: ${({ width }) => width};
`;

function Icon(props) {
  const {
    size,
    icon,
    className,
    color,
    optionalPath,
    optionalViewBox,
    onClick,
  } = props;

  const setOfPaths = icon ? iconPaths[icon]?.path || [] : optionalPath;

  if (isEmpty(setOfPaths)) {
    return null;
  }

  return (
    <StyledIcon
      className={className}
      color={color}
      height={`${size}px`}
      onClick={onClick}
      viewBox={iconPaths[icon]?.viewBox || optionalViewBox}
      width={`${size}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {setOfPaths.map((singlePath, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <path key={index} d={singlePath} fill="currentColor" />
      ))}
    </StyledIcon>
  );
}

Icon.defaultProps = {
  className: "",
  color: null,
  icon: null,
  onClick: () => {},
  optionalPath: null,
  optionalViewBox: null,
};

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  optionalPath: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  optionalViewBox: PropTypes.string,
  size: PropTypes.number.isRequired,
};

export default Icon;
